module.exports = __webpack_public_path__ + "img/T-coin-grey.e8e559e.png";